export default function validation(input) {
    let errors = {}
    const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const phone_pattern =/^\d{10}$/
    const aadhaar_pattern =/^\d{12}$/
    var status = true;

    
    if (!input.resume) {
        status = false;
        errors.resume = "Please upload resume.";
    }
    if (!input.name__first_name) {
        status = false;
        errors.name__first_name = "Please enter your name.";
    }

    if (!input.name__email) {
        status = false;
        errors.name__email = "Please enter your email address."
    }

    if (input.name__email && !email_pattern.test(input.name__email)) {
        status = false;
        errors.name__email = "Please enter a valid email address."
    }

    if (!input.name__phone) {
        status = false;
        errors.name__phone = "Please enter your phone number."
    }

    if (input.name__phone && !phone_pattern.test(input.name__phone)){
        status = false;
        errors.name__phone = "Please enter 10 digit phone number."
    }

    if (!input.addhar_number) {
        status = false;
        errors.addhar_number = "Please  enter your aadhaar number."
    }
    if (input.addhar_number && !aadhaar_pattern.test(input.addhar_number) ) {
        status = false;
        errors.addhar_number = "Please enter valid aadhaar number."
    }

    if (!input.address) {
        status = false;
        errors.address = "Please enter your address."
    }
    if (!input.gender) {
        status = false;
        errors.gender = "Please select your gender."
    }
    if (!input.Dob) {
        status = false;
        errors.Dob = "Please enter your date of birth."
    }
    if (!input.qualifications) {
        status = false;
        errors.qualifications = "Please enter your qualification."
    }
    if (!input.yearofpassing) {
        status = false;
        errors.yearofpassing = "Please enter year of passout."
    }
    if (!input.percentage) {
        status = false;
        errors.percentage = "Please enter your mark in percentage."
    }
    if (input.percentage && parseFloat(input.percentage) > 100) {
        status = false;
        errors.percentage = "Invalid mark! Please enter a value less than or equal to 100."
    }


    return {'errors':errors,'status':status};
}